import { get } from './requests'

export const getResponsibles = key => get(['responsibles'], { key, transformPayload: true })
export const getUserAgents = key => get(['get-user-agency'], { key })
